import { IAsset } from '../../Storage';
import FolderIcon from '~/assets/svg/newSvg/folder.svg?react';
import styles from './FolderCard.module.scss';
import { useTranslation } from 'react-i18next';

interface IFolderProps {
  asset: IAsset;
}

const FolderCard = ({ asset }: IFolderProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.card}>
      <FolderIcon className={styles.icon} />
      <p className={styles.name}>{asset.name}</p>
      <span className={styles.objects}>
        {t('objects')} {`(${asset.folder_count})`}
      </span>
    </div>
  );
};

export default FolderCard;
